import * as React from 'react';
import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import Home from '../../Dashboard/Home/Home';
import NotificationFeed from '../../Dashboard/Notifications/NotificationFeed';
import { Redirect } from 'react-router';

const moduleRoutes: RoutePathsFn = (userType: UserTypes) => ([
  {
    paths: [routes.ROOT, routes.HOME],
    component: userType === UserTypes.LAWENFORCEMENTAGENT ?
      () => <Redirect to={routes.MATCHESVIEW} /> : Home,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.NOTIFICATIONS],
    component: NotificationFeed,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  }
]);

export const dashboardModule = (userType: UserTypes): IRouteModule => ({
  name: RoutesModules.DASHBOARD,
  routes: moduleRoutes(userType),
  navbar: userType === UserTypes.LAWENFORCEMENTAGENT ? routes.NOTIFICATIONS : routes.HOME,
  sidebar: [
    {
      navTitle: 'Notifications',
      route: routes.NOTIFICATIONS
    }
  ]
});